import React, { useContext } from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { OrganizationThemeContext } from '../../../lib/context/OrganizationThemeContext';

type Props = Omit<TextFieldProps, 'color' | 'variant'>;

const ThemableTextField = React.forwardRef<HTMLDivElement, Props>(
  (props: Props, ref): JSX.Element => {
    const { inputsColor } = useContext(OrganizationThemeContext);

    return (
      <TextField {...props} color={inputsColor} ref={ref} variant="outlined" />
    );
  }
);

export default ThemableTextField;
